export const CONTACT_EMAIL = 'prowycena.app@gmail.com';

export const CONTACT_MAILTO = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(
  'Pytanie o testy ProWyceny'
)}&body=${encodeURIComponent(
  'Dzień dobry,\n\nChcę przetestować ProWycenę lub zgłosić problem:\n\n'
)}`;

export type ClipboardWriter = Pick<Clipboard, 'writeText'>;

export async function copyContactEmail(
  clipboard: ClipboardWriter | undefined
): Promise<boolean> {
  if (!clipboard) return false;

  try {
    await clipboard.writeText(CONTACT_EMAIL);
    return true;
  } catch {
    return false;
  }
}
